import EventEmitter from 'eventemitter3'

export const eventEmitter = new EventEmitter()

export const EMITTER_EVENTS = {
  SIGN_IN: 'sign_in',
  SIGN_OUT: 'sign_out',
}
